import { CalendarCheckIcon, ClipboardListIcon, UserRoundIcon, MessageSquareIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type TrustItem = {
  id: string
  icon: LucideIcon
  title: string
  description: string
}

export const trustItems: TrustItem[] = [
  {
    id: 'agenda',
    icon: CalendarCheckIcon,
    title: 'Agenda en minutos',
    description: 'Sin formularios ni esperas. Escríbenos por WhatsApp y coordinamos tu visita directamente.',
  },
  {
    id: 'diagnostico',
    icon: ClipboardListIcon,
    title: 'Diagnóstico explicado',
    description: 'Te mostramos qué necesitas, por qué y cuánto tiempo toma',
  },
  {
    id: 'plan',
    icon: UserRoundIcon,
    title: 'Plan para tu caso',
    description: 'No hay un tratamiento para todos. Diseñamos el tuyo',
  },
  {
    id: 'contacto',
    icon: MessageSquareIcon,
    title: 'Contacto directo',
    description: 'Escríbenos por WhatsApp y te orientamos antes de agendar',
  },
]

export const differentiators: string[] = [
  'Te explicamos qué encontramos antes de iniciar cualquier procedimiento.',
  'Diagnóstico en lenguaje que entiendas, no en términos técnicos.',
  'Preguntas bienvenidas en cualquier momento del proceso.',
  'Seguimiento después de tu cita cuando el tratamiento lo requiere.',
  'Contacto fácil por WhatsApp antes, durante y después.',
]
